module.exports = __webpack_public_path__ + "static/image/history/pc/202308.ver2_0_2.jpg?0e12790b";